"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useModalState = require("../../../utils/useModalState");
var _Button = require("../../../components/Button");
var _Modal = require("../../../components/Modal");
var _PatientEmployerRelationsDetailsTable = _interopRequireDefault(require("./PatientEmployerRelationsDetailsTable"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PatientEmployerRelationsDetails = function PatientEmployerRelationsDetails(_ref) {
  var patientId = _ref.patientId,
    relations = _ref.relations,
    loading = _ref.loading;
  var modal = (0, _useModalState.useModalState)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.TextButton, {
    size: "small",
    className: "ml-[75%]",
    onClick: modal.show
  }, "All Records"), /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    title: "Patient\u2019s Employer Relations History",
    visible: modal.visible,
    onCancel: modal.hide,
    footer: null,
    width: 950,
    destroyOnClose: true
  }, /*#__PURE__*/_react.default.createElement(_PatientEmployerRelationsDetailsTable.default, {
    patientId: patientId,
    relations: relations,
    loading: loading
  })));
};
var _default = PatientEmployerRelationsDetails;
exports.default = _default;